import flatten from "lodash/flatten";

export const META_CONTENT = {
	siteName: "OkCupid | Free Online Dating",
	description: "OkCupid is the only dating app that knows you’re more substance than just a selfie—and it’s free! Download it today to make meaningful connections with real people.",
	thumbPath: "media/img/logos/2019/1024.png",
};

// Add new authed paths here.
export const AUTHED_ROUTES = {
	Doubletake: ["/doubletake", "/home"],
	Discovery: ["/discovery"],
	MatchSearch: ["/match"],
	Messages: ["/messages"],
	StandaloneConversation: ["/standalone_conversation"],
	WhoLikesYou: ["/who-likes-you"],
	WhoYouLike: ["/who-you-like", "/mutual-likes"],
	Intros: ["/intros"],
	ProfileMain: ["/profile", "/profile/:userid"],
	ProfileQuestions: ["/profile/:userid/questions"],
	ProfilePhotos: ["/profile/:userid/photos"],
	Settings: ["/settings", "/settings/:page"],
	Boosts: ["/boost"],
	Upgrade: ["/upgrade"],
	Incognito: ["/incognito"],
	Onboarding: ["/onboarding", "/onboarding/react"],
	Offboarding: ["/offboarding"],
	PhoneWall: ["/phone"],
};

// Add new unauthed paths here.
export const UNAUTHED_ROUTES = {
	Splash: ["/", "/login", "/login-direct"],
	SplashLogin: ["/login", "/login-direct"],
	AccountReactivate: ["/l/:autologinToken", "/reactivate"],
	Signup: ["/signup", "/joinus"],
	Logout: ["/logout"],
};

export const ROUTES = {
	...AUTHED_ROUTES,
	...UNAUTHED_ROUTES,
};

export const AUTHED_ROUTE_LIST = flatten(
	Object.values(AUTHED_ROUTES),
);

export const UNAUTHED_ROUTE_LIST = flatten(
	Object.values(UNAUTHED_ROUTES),
);

export const ROUTE_LIST = flatten(
	Object.values(ROUTES),
);

export const ROUTE_TITLES = {
	Doubletake: "DoubleTake",
	Discovery: "Discover",
	MatchSearch: "Matches",
	Messages: "Conversations",
	StandaloneConversation: "Conversation",
	WhoLikesYou: "Who Likes You",
	WhoYouLike: "Who You Like",
	Intros: "Intros",
	ProfileMain: "Profile",
	ProfileQuestions: "Profile Questions",
	ProfilePhotos: "Profile Photos",
	Settings: "Settings",
	Boosts: "Get Boost",
	Upgrade: "Upgrade to A-List",
	Incognito: "Incognito",
	Logout: "Goodbye!",
	Splash: "Free Online Dating",
	SplashLogin: "Free Online Dating",
	Signup: "Free Online Dating",
	Onboarding: "Onboarding",
	Offboarding: "Before you go...",
	Phone: "Secure your account",
};



// WEBPACK FOOTER //
// ./src/routers/shared/util/consts.js